import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
// action types
export const UPDATE_TABLE_STRUCTURE = "getINTEGRATIONSTableStructure";
export const UPDATE_TABLE_DATA = "getINTEGRATIONSTableData";
export const UPDATE_CREATE_DATA = "getINTEGRATIONSCreateData";
export const EXPORT_TABLE_DATA = "exportINTEGRATIONSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setINTEGRATIONSTableStructure";
export const SET_TABLE_DATA = "setINTEGRATIONSTableData";
export const SET_TABLE_FILTER = "setINTEGRATIONSTableFilter";
export const SET_TABLE_PAGE = "setINTEGRATIONSTablePage";
export const SET_TABLE_PERPAGE = "setINTEGRATIONSTablePerPage";
export const SET_TABLE_SORTBY = "setINTEGRATIONSTableSortBy";
export const SET_TABLE_SORTORDER = "setINTEGRATIONSTableSortOrder";
export const SET_EXPORT_LINK = "setINTEGRATIONSExportLink";
export const SET_CREATE_DATA = "setINTEGRATIONSCreateData";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  create_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getINTEGRATIONSTableState(state) {
    return state.table_state;
  },

  getINTEGRATIONSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getINTEGRATIONSTableFilters(state) {
    return state.table_structure.filters;
  },

  getINTEGRATIONSTablePermissions(state) {
    return state.table_structure.permissions;
  },

  getINTEGRATIONSTableData(state) {
    return state.table_data.data;
  },

  getINTEGRATIONSTableProperties(state) {
    return state.table_structure.properties;
  },

  getINTEGRATIONSExportUrl(state) {
    return state.export_link;
  },

  getINTEGRATIONSCustomers(state) {
    return state.create_data.customers;
  },

  getINTEGRATIONSPlatforms(state) {
    return state.create_data.platforms;
  },

  getINTEGRATIONSValidations(state) {
    return state.create_data.validations;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/datahub/integrations")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_CREATE_DATA](context) {
    return new Promise((resolve) => {
      ApiService.post("datahub/integrations/create")
        .then(({ data }) => {
          context.commit(SET_CREATE_DATA, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/datahub/integrations/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/datahub/integrations/export", payload)
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
  [SET_CREATE_DATA](state, create_data) {
    state.create_data = create_data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
